module.exports = __webpack_public_path__ + "static/c-1a439c36ec20dacc480037920f0a0697.png";